export const getProceduresFrag = `
    code
    customCode
    customName
    color
    procedure {
        description
    }
`;

export const getServiceAnnouncementTypesFrag = `
    id
    name
`;
